webpackJsonp([35783957827783],{

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = exports = self.fetch;
	
	// Needed for TypeScript and Webpack.
	exports.default = self.fetch.bind(self);
	
	exports.Headers = self.Headers;
	exports.Request = self.Request;
	exports.Response = self.Response;


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fia_icon_large.aafe58b2.png";

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/financial_analysis.390d3837.png";

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _signupModule = __webpack_require__(75);
	
	var _signupModule2 = _interopRequireDefault(_signupModule);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _services = __webpack_require__(47);
	
	var _classnames = __webpack_require__(50);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Signup = function (_React$Component) {
	  _inherits(Signup, _React$Component);
	
	  function Signup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Signup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      email: '',
	      error: null,
	      loading: false
	    }, _this.validateEmail = function (email) {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(String(email).toLowerCase());
	    }, _this.handleEmailChange = function (evt) {
	      _this.setState({ email: evt.target.value, error: null });
	    }, _this.handleSignup = function (evt) {
	      evt.preventDefault();
	
	      if (_this.state.email == '') {
	        return;
	      }
	
	      if (!_this.validateEmail(_this.state.email)) {
	        _this.setState({ error: 'That doesn\'t look like a valid email address' });
	        return;
	      }
	
	      _this.setState({ loading: true });
	
	      (0, _services.createSubscriber)(_this.state.email).then(function (data) {
	        if (!data.metadata.success) {
	          _this.setState({ error: data.metadata.message, loading: false });
	          return;
	        } else {
	          (0, _gatsbyLink.push)('/signup-success');
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Signup.prototype.render = function render() {
	    var btnClass = (0, _classnames2.default)('btn', 'btn-primary', 'input-group-btn', 'btn-lg', {
	      'loading': this.state.loading
	    });
	    var groupClass = (0, _classnames2.default)('form-group', {
	      'has-error': this.state.error
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: _signupModule2.default.root },
	      _react2.default.createElement(
	        'h5',
	        { style: { textAlign: "center" } },
	        'Join the waitlist'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: groupClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'input-group' },
	          _react2.default.createElement('input', {
	            className: 'form-input input-lg',
	            placeholder: 'Enter email address',
	            type: 'text',
	            value: this.state.email,
	            onChange: this.handleEmailChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: {
	              display: "flex",
	              justifyContent: "center",
	              marginTop: "12px"
	            } },
	          _react2.default.createElement(
	            'button',
	            {
	              className: btnClass,
	              style: {
	                borderRadius: "25px",
	                justifyContent: 'center',
	                width: '80%',
	                backgroundColor: '#444643'
	              },
	              type: 'button',
	              onClick: this.handleSignup
	            },
	            this.state.loading ? null : _react2.default.createElement(
	              'p',
	              { style: {
	                  color: 'white',
	                  fontSize: 18,
	                  fontWeight: '400',
	                  textTransform: 'uppercase'
	                } },
	              'Sign Up'
	            )
	          )
	        ),
	        this.state.error ? _react2.default.createElement(
	          'p',
	          { style: { margin: "8px", textAlign: "center" }, className: 'form-input-hint' },
	          this.state.error
	        ) : null
	      )
	    );
	  };
	
	  return Signup;
	}(_react2.default.Component);
	
	exports.default = Signup;
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----signup-module---root---eOHh5","error":"src-components----signup-module---error---2auyC"};

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _signup = __webpack_require__(129);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _financial_analysis = __webpack_require__(288);
	
	var _financial_analysis2 = _interopRequireDefault(_financial_analysis);
	
	var _fia_icon_large = __webpack_require__(83);
	
	var _fia_icon_large2 = _interopRequireDefault(_fia_icon_large);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	
	  function useWindowSize() {
	    var _useState = (0, _react.useState)({
	      width: undefined,
	      height: undefined
	    }),
	        windowSize = _useState[0],
	        setWindowSize = _useState[1];
	
	    (0, _react.useEffect)(function () {
	      // Handler to call on window resize
	      function handleResize() {
	        // Set window width/height to state
	        setWindowSize({
	          width: window.innerWidth,
	          height: window.innerHeight
	        });
	      }
	
	      // Add event listener
	      window.addEventListener("resize", handleResize);
	
	      // Call handler right away so state gets updated with initial window size
	      handleResize();
	
	      // Remove event listener on cleanup
	      return function () {
	        return window.removeEventListener("resize", handleResize);
	      };
	    }, []); // Empty array ensures that effect is only run on mount
	
	    return windowSize;
	  }
	
	  var size = useWindowSize();
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    size.width >= 960 ? _react2.default.createElement(
	      'div',
	      { style: { width: "960px" }, className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column col-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { style: { height: "32px" } }),
	              _react2.default.createElement(
	                'h2',
	                { style: { color: "#444643" } },
	                'Fia Finance was built to help couples manage the complexities of their finances.'
	              ),
	              _react2.default.createElement('div', { style: { height: "16px" } }),
	              _react2.default.createElement(
	                'h4',
	                { style: { color: "#444643" } },
	                'Modern relationships rarely look like those of our parents\' generation, so why are we still banking as if they do?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: "flex", justifyContent: "center" } },
	                _react2.default.createElement(_signup2.default, null)
	              ),
	              _react2.default.createElement('div', { style: { height: "32px" } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column col-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hero' },
	            _react2.default.createElement('img', { className: 'hero-image', src: _financial_analysis2.default })
	          )
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { style: { width: size.width - 32, margin: "16px" }, className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column col-12' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { style: { height: "32px" } }),
	            _react2.default.createElement(
	              'h2',
	              { style: { textAlign: "center", color: "#444643" } },
	              'Fia Finance was built to help couples manage the complexities of their finances.'
	            ),
	            _react2.default.createElement('div', { style: { height: "16px" } }),
	            _react2.default.createElement(
	              'h4',
	              { style: { textAlign: "center", color: "#444643" } },
	              'Modern relationships rarely look like those of our parents\' generation, so why are we still banking as if they do?'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: "flex", justifyContent: "center" } },
	              _react2.default.createElement(_signup2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: "flex", justifyContent: "center" } },
	            _react2.default.createElement('img', { style: { width: size.width * 0.8, height: size.width * 0.8 }, src: _financial_analysis2.default })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createSubscriber = undefined;
	
	var _nodeFetch = __webpack_require__(81);
	
	var _nodeFetch2 = _interopRequireDefault(_nodeFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createSubscriber = exports.createSubscriber = function createSubscriber(email) {
	  var url = ("https://31q4w9akg2.execute-api.us-east-1.amazonaws.com/dev/subscriber/create");
	  var listId = ("23131648-8bed-11eb-a3d0-06b4694bee2a");
	
	  return (0, _nodeFetch2.default)(url, {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({
	      listId: listId,
	      email: email
	    })
	  }).then(function (response) {
	    return response.json();
	  });
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-df75e67b0d0d8ef92e02.js